export type SupportedLocale = 'en' | 'ar';

export const supportedLocales: ReadonlyArray<SupportedLocale> = ['en', 'ar'];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

/** App-scoped namespaces. Add new ones here when an SPA needs its own bundle. */
export const namespaces = [
  'common',
  'operator',
  'ssp',
  'admin',
  'commissioning',
  'fleet',
  'video',
] as const;
export type Namespace = (typeof namespaces)[number];
